<template>
    <div>
        <header id="masthead" itemtype="https://schema.org/WPHeader" itemscope="">
            <div class="inside-header flex flex-row align-middle">
                <div class="w-1/4">
                    <a href="" title="DegreeData" rel="home">
                        <img
                            class="header-image site-logo"
                            alt="DegreeData"
                            src="/wp-content/uploads/2018/08/degreedata_logo.png"
                            title="DegreeData"
                        />
                    </a>
                </div>
                <nav class="w-3/4">
                    <div class="flex flex-row">
                        <ul class="flex justify-around pl-10 pt-2 uppercase text-gray-500" style="font-size: 17px">
                            <li class="inline">
                                <a href="/about-degreedata/">About</a>
                            </li>
                            <li class="inline">
                                <a href="/news/">News</a>
                            </li>
                            <li class="inline active">
                                <a href="/solutions/">Solutions</a>
                            </li>
                            <!-- <li class="inline">
                                <a href="https://wp.degreedata.dev/membership-options/">Subscribe</a>
                            </li> -->

                            <li class="inline">
                                <a href="/curriculum-finder/">Curriculum Search</a>
                            </li>
                            <!-- <li class="inline">
                                <a href="https://wp.degreedata.dev/my-account/"
                                    >My Account<span role="presentation" class="dropdown-menu-toggle"></span
                                ></a>
                            </li> -->
                        </ul>
                    </div>
                </nav>
            </div>
        </header>
    </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.inside-header {
    padding: 20px 40px 0 0;
}

.site-logo {
    max-width: 220px;
    display: inline-block;
}

.inside-header .inline a {
    color: #727272;
}

.inside-header .inline.active a {
    color: #ff7700;
}
</style>
